import { ROUTERS, TextMessage } from '@/constant';
import { searchParamsKey, useCreateListSubmit } from '@/hooks';
import { useAppSelector } from '@/stores';
import {
	WorkerApplicantActions,
	WorkerApplicantSelectors,
} from '@/stores/worker-applicant';
import { showAlert } from '@/utils';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import Button from '../common/button';
import { IssueApplicationDownloadViewProps } from './issue-application-download.type';

const IssueApplicantButton = ({
	refTableId,
	fullName,
	refTableName,
	applicantData,
	className,
}: IssueApplicationDownloadViewProps) => {
	const paramsCheckIssueApplicationDownload = useAppSelector(
		WorkerApplicantSelectors.selectParamsListsDetailAssignment
	);

	const dispatch = useDispatch();

	const { onCreateSubmit } = useCreateListSubmit({
		toCreatePathName: '',
	});

	const onCheckIsIssueApplicationDownload = useCallback(() => {
		dispatch(
			WorkerApplicantActions.getWorkerApplicantAssignmentListRequest({
				...paramsCheckIssueApplicationDownload,
				id: refTableId as number,
				callback({ total }: { total: number }) {
					if (total === 0) {
						showAlert(TextMessage.ALERT_84);
						return;
					}
					const queryProps = {
						refTableId,
						fullName,
						refTableName,
					};
					const pathName = `${ROUTERS.ISSUE_APPLICATION_DOWNLOAD}?${searchParamsKey}=${encodeURIComponent(JSON.stringify(queryProps))}`;

					onCreateSubmit?.({
						pathName: pathName,
					});
				},
			})
		);
	}, [
		paramsCheckIssueApplicationDownload,
		refTableId,
		fullName,
		refTableName,
		onCreateSubmit,
	]);

	const onClick = useCallback(() => {
		if (applicantData && applicantData?.length > 1) {
			showAlert(TextMessage.ALERT_72);
			return;
		} else if (!applicantData || applicantData?.length === 0) {
			showAlert('근로자를(을) 선택해주세요.');
			return;
		} else {
			onCheckIsIssueApplicationDownload();
		}
	}, [applicantData, onCheckIsIssueApplicationDownload]);

	return (
		<Button name="register" onClick={onClick} className={className}>
			발급·신청 별 서류 다운로드
		</Button>
	);
};

export default memo(IssueApplicantButton);
